export const getFundFromSize = (ordersList, size) => {
    let fund = 0;
    let sizePassed = 0;
  
    ordersList.some(order => {
      sizePassed += order.size;
      if (sizePassed > size) {
        sizePassed -= order.size;
        const sizeResidue = size - sizePassed;
        fund += sizeResidue * order.unitPrice;
        return true;
      }
  
      fund += order.size * order.unitPrice;
    });
  
    return fund;
  };